import React from 'react';
import { ServiceTemplate } from '../ServiceTemplate';
import { amazonBrandRegistryData } from '../../servicesData';

export const AmazonBrandRegistry = ({ onOpenPopup }) => {
  return (
    <ServiceTemplate
      service={amazonBrandRegistryData}
      onOpenPopup={onOpenPopup}
      showPricing={false}
    />
  );
};